<template>
  <div class="content">
    <van-nav-bar
      :title="title"
      :border="false"
      @click-left="onClickLeft"
      fixed
      z-index="999"
    >
      <template #left>
        <van-icon name="arrow-left" size="20" color="#ffffff" />
      </template>
    </van-nav-bar>
  </div>
</template>
<script>
function browserWindow() {
  try {
    return typeof window === 'undefined' ? null : window
  } catch (e) {
    return null
  }
}

export default {
  name: 'TitleBar',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.$nextTick(() => {
      try {
        const win = browserWindow()
        if (win && typeof win.scrollTo === 'function') {
          win.scrollTo(0, 0)
        }
      } catch (e) {
        // Ignore restricted WebView scroll failures.
      }
    })
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding-top: 55px;
}
</style>
